import { Component, OnInit, Input } from '@angular/core';
import { textField } from './change-email-conditions-subscriptions';

import { AlgConsensoService } from '../../../services/alg-consenso.service';
import {
  DocsReceptionRequestType,
  RicezioneDocumenti,
} from '../../../models/fisso';

@Component({
  selector: 'alg-email-management-info-subscription',
  templateUrl: './alg-email-management-info-subscription.component.html',
  styleUrls: ['./alg-email-management-info-subscription.component.scss'],
})
export class AlgEmailManagementInfoSubscriptionComponent {
  @Input() type: DocsReceptionRequestType;
  @Input() data: RicezioneDocumenti;
  @Input() email: string;

  public textField = textField;
  constructor() {}

  getText(): string {
    if (this.type == undefined) {
      return '';
    }
    switch (this.type) {
      case DocsReceptionRequestType.registration:
        return textField.registerEmail(
          this.data.customerCode || "",
          this.data.address || "",
          this.email
        );
      case DocsReceptionRequestType.update:
        return textField.changeEmail(
          this.data.customerCode || "",
          this.email,
          this.data.modifiedAsset || ""
        );
      case DocsReceptionRequestType.delete:
        return textField.deleteEmail(this.data.customerCode || "", this.email, this.data.address);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alg-email-management/alg-email-management-info-subscription/alg-email-management-info-subscription.component.ts